import React from 'react';
import TotalToggle from 'pages/search/components/filters/modules/transient/total-toggle';
import { MonthlyAvailability } from './availability/MonthlyAvailability';
import useIsMobile from 'hooks/use-is-mobile';
export const FiltersMonthly = () => {
    const isMobile = useIsMobile();
    const filters = [
        <TotalToggle key="TotalToggle"/>,
        <MonthlyAvailability key="MonthlyAvailability"/>,
    ];
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{isMobile ? filters : filters.reverse()}</>;
};
